import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { LOGO_LIGHT } from "@/lib/images";
import { Instagram } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-forest-2 text-ivory pt-20 pb-10"
      style={{ background: "var(--yz-forest-2)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 pb-16 border-b border-ivory/20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_LIGHT}
                alt="Yuzenya"
                className="h-14 w-14 object-contain"
              />
              <span className="font-serif text-ivory text-2xl tracking-[0.2em]">YUZENYA</span>
            </div>
            <p className="mt-8 font-serif text-2xl md:text-3xl text-ivory leading-snug max-w-md font-light">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-bronze mb-4">{t.footer.contact}</p>
            <p className="text-ivory leading-relaxed">
              hello@yuzenya.com
            </p>
            <a
              href="https://www.instagram.com/yuzenya.official"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow Yuzenya on Instagram"
              data-testid="footer-instagram-link"
              className="group mt-6 inline-flex items-center gap-2 text-ivory/70 hover:text-bronze transition-colors duration-300"
            >
              <Instagram
                size={18}
                strokeWidth={1.5}
                className="transition-transform duration-300 group-hover:scale-110"
              />
              <span className="overline">@yuzenya.official</span>
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-bronze mb-4">About Yuzenya</p>
            <p className="text-sm leading-relaxed text-ivory/85" data-testid="footer-description">
              {t.footer.description}
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 overline text-ivory/75">
          <span>© {year} Yuzenya. {t.footer.rights}</span>
          <span>{t.footer.development}</span>
        </div>
      </div>
    </footer>
  );
};
